module.exports = __webpack_public_path__ + "assets/img/63.f00679cb.png";